import React from "react";
import styled from "styled-components";
import logo from "../../../../../assets/svgs/logo-dark.svg";

const Wrapper = styled.div`
  text-align: center;
`;

const Header = ({ text }) => {
  return (
    <Wrapper>
      <img
        src={logo}
        alt={`${String(
          process.env.REACT_APP_TRIBE_NAME,
        ).toLowerCase()}-lending`}
      />
      <p className="note">{text}</p>
    </Wrapper>
  );
};

export default Header;
